export { Waveform } from './Waveform'
export type { WaveformProps } from './Waveform'
export { getWaveformColors, containerStyles } from './Waveform.styles'
